import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  data: [],
  status: 'idle',
  error: null,
};

export const getRealEstateTypes = createAsyncThunk(
  'realEstateTypes/getRealEstateTypes',
  async () => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_URL}/RealEstateTypes`,
        headers: {
          ContentType: 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export const realEstateTypeSlice = createSlice({
  name: 'realEstateType',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getRealEstateTypes.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getRealEstateTypes.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(getRealEstateTypes.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default realEstateTypeSlice.reducer;
